(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/betslip.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/betslip.js');
"use strict";

const {
  BetslipProvider,
  BetslipSelector
} = svs.components.tipsen.betslip;
const Betslip = _ref => {
  let {
    toggleOverview
  } = _ref;
  return React.createElement(BetslipProvider, {
    toggleOverview: toggleOverview
  }, React.createElement(BetslipSelector, null));
};
setGlobal('svs.components.tipsen.betslip.Betslip', Betslip);

 })(window);